import axios from 'axios';
import { LeadsWindowModel } from '../models/LeadsWindowModel';

const API_URL = process.env.REACT_APP_API_URL;

interface CreateLeadsWindowBody {
  shift: LeadsWindowModel['shift'];
  from_date: string;
  to_date: string;
  sale_agent: number;
}

export async function createLeadsWindow(
  body: CreateLeadsWindowBody
): Promise<{ data: LeadsWindowModel }> {
  return axios.post(`${API_URL}/api/crm/leads-windows/`, body);
}
